module.exports = __webpack_public_path__ + "img/hotbit.ce403d1a.png";